import * as actionTypes from "../Actions/InvoicesActionTypes";
import LogService from "../../CommonSdk/LogService";

const LOG_TAG = "REDUCER:INVOICES";

const initialState = {
    invoices: [],
    invoice: null,
    account: null,
    total: 0,
    
    error: {
        errorCode: "",
        errorMessage: ""
    },

    updateOptionError: {
        errorCode: "",
        errorMessage: ""
    },

    getAccountProgress: false,
    updateOptionProgress: false,
    getInvoiceProgress: false,
    downloadInvoiceFileProgress: false
};

const clearError = () => {
    return {
        errorCode: "",
        errorMessage: ""
    };
};

export default function (state = initialState, action) {
    switch (action.type) {

        // case actionTypes.CREATE_INVOICES_ACCOUNT_PROGRESS:
        //     LogService.info(LOG_TAG, "reduce", "" + action.type + " - Create invoice account in progress");
        //     return {
        //         ...state,
        //         createAccountProgress: true
        //     };

        case actionTypes.CREATE_INVOICES_ACCOUNT_DONE:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Create invoice account done");
            return {
                ...state,
                account: action.payload.account,
                // createAccountProgress: false,
                // error: clearError()
            };

        // case actionTypes.CREATE_INVOICES_ACCOUNT_ERROR:
        //     LogService.warn(LOG_TAG, "reduce", "" + action.type + " - Create invoice account failed");
        //     return {
        //         ...state,
        //         createAccountProgress: false,
        //         error: {
        //             errorCode: action.payload.errorCode,
        //             errorMessage: action.payload.errorMessage
        //         }
        //     };


        case actionTypes.GET_INVOICES_ACCOUNT_PROGRESS:  
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get invoice account in progress");
            return {
                ...state,
                getAccountProgress: true
            };
        
        case actionTypes.GET_INVOICES_ACCOUNT_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get invoice account received");
            return {
                ...state,
                account: action.payload.account,
                getAccountProgress: false,
                error: clearError()
            };

        case actionTypes.GET_INVOICES_ACCOUNT_ERROR:
            LogService.warn(LOG_TAG, "reduce", "" + action.type + " - Get invoice account failed with error=" + action.payload.errorCode);
            return {
                ...state,
                getAccountProgress: false,
                error: {
                    errorCode: action.payload.errorCode,
                    errorMessage: action.payload.errorMessage
                }
            };

        // case actionTypes.UPDATE_INVOICES_INFO_PROGRESS:                
        //     LogService.info(LOG_TAG, "reduce", "" + action.type + " - Update invoice informations in progress");
    
        //     return {
        //         ...state,
        //         updateInfoProgress: true
        //     };

        case actionTypes.UPDATE_INVOICES_INFO_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Update invoice informations done");
            return {
                ...state,
                account: action.payload.account,
                // updateInfoProgress: false,
                // updateInfoError: clearError()
            };  

        // case actionTypes.UPDATE_INVOICES_INFO_ERROR:
        //     LogService.warn(LOG_TAG, "reduce", "" + action.type + " - Update invoice informations failed with error=" + action.payload.errorCode);
        //     return {
        //         ...state,
        //         updateInfoProgress: false,
        //         updateInfoError: {
        //             errorCode: action.payload.errorCode,
        //             errorMessage: action.payload.errorMessage
        //         },
        //     };
        
        case actionTypes.UPDATE_INVOICES_OPTIONS_PROGRESS:                   
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Update invoice options in progress");
    
            return {
                ...state,
                updateOptionProgress: true
            };

        case actionTypes.UPDATE_INVOICES_OPTIONS_SUCCESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - update invoice options done");
            
            return {
                ...state,
                account: action.payload.account,
                updateOptionProgress: false,
                error: clearError()
            };
           
        case actionTypes.UPDATE_INVOICES_OPTIONS_ERROR:           
            LogService.warn(LOG_TAG, "reduce", "" + action.type + " - Update invoice options failed");
            return {
                ...state,
                updateOptionProgress: false,
                updateOptionError: {
                    errorCode: action.payload.errorCode,
                    errorMessage: action.payload.errorMessage
                },
            };
            
        case actionTypes.GET_INVOICES_PROGRESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get invoice file in progress");
            return {
                ...state,
                getInvoiceProgress: true
            };

        case actionTypes.GET_INVOICES_DONE:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get invoice file in done");
            return {
                ...state,
                invoices: action.payload.invoices,
                total: action.payload.total,
                getInvoiceProgress: false
            };

        case actionTypes.GET_INVOICES_ERROR:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Get invoice file in failed");
            return {
                ...state,
                getInvoiceProgress: false,
                error: {
                    errorCode: action.payload.errorCode,
                    errorMessage: action.payload.errorMessage
                },
            };

        case actionTypes.DOWNLOAD_INVOICES_PROGRESS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Download invoice file in progress");
            return {
                ...state,
                downloadInvoiceFileProgress: true
            };

        case actionTypes.DOWNLOAD_INVOICES_DONE:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Download invoice file in progress");
            return {
                ...state,
                invoice: action.payload.invoice,
                downloadInvoiceFileProgress: false
            };

        case actionTypes.DOWNLOAD_INVOICES_ERROR:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Download invoice file in progress");
            return {
                ...state,
                downloadInvoiceFileProgress: false,
                error: {
                    errorCode: action.payload.errorCode,
                    errorMessage: action.payload.errorMessage
                },
            };

        case actionTypes.CLEAR_INVOICES_METHODS:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Clear invoices methods");
            return {
                ...initialState,
            };

        default:
            return state;    
    }
}